<script lang="ts">
  import { v4 as v4uuid } from 'uuid';
  import { paramsService } from "../services";
  import { Param } from "../Model/Param";
  import { Icon } from "sveltestrap";
  import AddParamModal from './AddParamModal.svelte';
    import { createEventDispatcher } from 'svelte';


  export let paramSelectId: string;
  export let paramType: string;
  export let nothing: boolean;

  const dispatch = createEventDispatcher();

  let params: Param[];
  let paramTypeModal = null;
  let addParam: boolean = false;
  let newParam: Param ;

  loadTypes();

  async function loadTypes() {
    
    params = await paramsService.findByType(paramType);

    params.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    if (nothing) {
      params.unshift(
        new Param({
          id: null,
          name: "Sin selección",
          type: null,
        })
      );
    }

    params = params;
  }

  function addNewParam(param) {
    if (param?.type == paramTypeModal) {
      params.push(param);
      params = params;
    }
  }

</script>

{#if params?.length > 0}
  <div class="input-group">
    <select class="form-select" bind:value={paramSelectId} on:change={() => {dispatch('changed', paramSelectId)}}>
      {#each params as param}
        <option value={param.id}>{param.name}</option>
      {/each}
    </select>
    <button
      class="btn btn-secondary"
      type="button"
      on:click={() => {
        addParam = true;
        paramTypeModal = paramType;
        newParam = new Param({
				  id : v4uuid(), 
				  name : '', 
				  type : paramType
			  });
      }}><Icon name="plus" /></button
    >
  </div>
{:else}
  <div class="input-group">
    <input
      class="form-control"
      type="text"
      placeholder="No hay parámetros"
      disabled
    />
    <button
      class="btn btn-secondary"
      type="button"
      on:click={() => {
        addParam = true;
        paramTypeModal = paramType;
        newParam = new Param({
				  id : v4uuid(), 
				  name : '', 
				  type : paramType
			  });
      }}><Icon name="plus" /></button
    >
  </div>
{/if}

<AddParamModal
  bind:open={addParam}
  type={paramType}
  editParam={newParam}
  removeButton={false}
  on:addParam={(event) => addNewParam(event.detail)}
/>

<style>
</style>
